import { clsx } from "clsx";
import type { InputHTMLAttributes } from "react";

/** The prototype's field (spec §8.21): surface, strong border, accent focus ring. */
export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={clsx(
        "kss-control kss-field w-full px-3 py-[9px] text-sm text-neutral-900 dark:text-neutral-100",
        className,
      )}
      {...props}
    />
  );
}
